import { FC } from "react";
import { Checkbox } from "antd";
import { clsx } from "clsx";
import classes from "./IhgTopicCard.module.less";

interface IhgTopicCardProps {
    id: string;
    label: string;
    description: string;
    checked?: boolean;
    onChange?: (id: string) => void;
}

export const IhgTopicCard: FC<IhgTopicCardProps> = ({
    id,
    checked,
    label,
    description,
    onChange,
}) => {
    return (
        <div
            className={clsx(classes.topicToggle, checked && classes.topicToggleOn)}
            onClick={() => onChange && onChange(id)}
        >
            <Checkbox checked={checked} />
            <div>
                <div className={classes.topicLabel}>{label}</div>
                <div className={classes.topicDesc}>{description}</div>
            </div>
        </div>
    );
};
